const ErrorMessage = (props) => {
  const { errorMessage } = props;

  if (!errorMessage) {
    return null;
  }
  return (
    <div className="c7-product__error" aria-describedby="qtyerror">
      Error: {errorMessage}
    </div>
  );
};

export default ErrorMessage;
